export default (filters) => {
  const filtersKeys = Object.keys(filters)
  let stringFilters = ''

  filtersKeys.forEach(key => {
    if (filters[`${key}`] !== null && filters[key] !== undefined && filters[key] !== '') {
      stringFilters += `${key}=${String(filters[key]).toLowerCase()}&`
    }
  })
  return stringFilters || ''
}



// WEBPACK FOOTER //
// ./src/helpers/formatAxiosGetFilters.js